import { createPinia } from 'pinia'

/**
 * Shared Pinia instance for app-web stores.
 */
const pinia = createPinia()

export default pinia
